import * as React from 'react';

const useModal = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleClose = () => setIsOpen(false);

  return {
    isOpen,
    setIsOpen,
    handleClose,
  };
};

export default useModal;
